module.exports = __webpack_public_path__ + "img/check.5c5099c9.svg";